export default __webpack_public_path__ + "a016e1a0f1e1e60eac87205bebdb22bc.png";